import React from "react";
import "./VerticalCard.scss";
import Shadow from "../../../assets/images/shadowVertical.svg";
import Tags from "../../Tags/Tags";

export default function VerticalCard({
  backgroundImage,
  name,
  title,
  description,
  tags,
  tagColor,
  tagBackground,
  tagTitle,
}) {
  return (
    <div
      className="verticalCardWrapper"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="gradient-overlay">
        <div className="over" style={{ padding: "100px 10px 10px 10px" }}>
          <h4>{name}</h4>
          <h2>{title}</h2>
          <div className="tags">
            <Tags
              color={tagColor}
              backgroundColor={tagBackground}
              title={tagTitle}
            />
          </div>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}
